import { getPropertyAddress } from '@/utils/properties';
import { ChartLine } from 'lucide-react';
import DoorIcon from '@/assets/icons/DoorIcon';
import HousePentagonAltIcon from '@/assets/icons/HousePentagonAltIcon';
import ProfileIcon from '@/assets/icons/ProfileIcon';
import ScrewDriverIcon from '@/assets/icons/ScrewdriverIcon';
import FileFolderIcon from '@/assets/icons/FileFolderIcon';
import ToolBoxIcon from '@/assets/icons/ToolBoxIcon';
import Bell from '@/assets/icons/Bell';
import BoligmappaPlusHomeIcon from '@/assets/icons/BoligmappaPlusHomeIcon';
import PersonalAreaIcon from '@/assets/icons/PersonalAreaIcon';
import ContractTemplatesIcon from '@/assets/icons/ContractTemplatesIcon';
import SupportMenuItemIcon from '@/assets/icons/SupportMenuItemIcon';
import HomeIcon from '../assets/icons/Home';
import LoginIcon from '../assets/icons/Login';
import HomeIconActive from '../assets/icons/HomeActive';
import FileIcon from '../assets/icons/FileIcon';
import CalendarIcon from '../assets/icons/CalendarIcon';
import EventsIcon from '../assets/icons/EventsIcon';
import DocumentsIcon from '../assets/icons/DocumentsIcon';
import RoomIcon from '../assets/icons/RoomIcon';
import HomePageIcon from '../assets/icons/HomePageIcon';
import HouseSimpleIcon from '../assets/icons/HouseSimpleIcon';
import MDRIcon from '../assets/icons/MDRIcon';
import CalendarActiveIcon from '../assets/icons/CalendarActiveIcon';
import FileActiveIcon from '../assets/icons/FileActiveIcon';
import PersonShelter from '../assets/icons/PersonShelter';
import BoligmappaFolder from '../assets/icons/BoligmappaFolder';
import BoligmappaFolderActive from '../assets/icons/BoligmappaFolderActive';
import ContractTemplate from '../assets/icons/ContractTemplate';
import ContractTemplateActive from '../assets/icons/ContractTemplateActive';
import DocumentsStateIcon from '../assets/icons/DocumentsStateIcon';

export const privateNavbarMenu = [
  {
    id: 0,
    title: 'Oversikt',
    icon: () => HomePageIcon({ fill: '#000' }),
    activeIcon: HomePageIcon,
    link: 'home',
  },
  {
    id: 1,
    title: 'Hendelser',
    icon: () => EventsIcon({ fill: '#000' }),
    activeIcon: EventsIcon,
    link: 'history',
  },
  {
    id: 2,
    title: 'Tilstand',
    icon: () => DocumentsStateIcon({ fill: '#000' }),
    activeIcon: DocumentsStateIcon,
    documentsToSignedOnly: true,
    link: 'condition',
  },
  {
    id: 3,
    title: 'Dokumenter',
    icon: () => DocumentsIcon({ fill: '#000' }),
    activeIcon: DocumentsIcon,
    link: 'documents',
  },
  {
    id: 4,
    title: 'Rom',
    icon: () => RoomIcon({ fill: '#000' }),
    activeIcon: RoomIcon,
    secondary: true,
    link: 'rooms',
  },
];

export const mobileNavbarMenu = [
  {
    title: 'Hjem',
    icon: (props) => HomePageIcon({ fill: '#000', ...props }),
    activeIcon: HomePageIcon,
    link: 'home',
  },
  {
    title: 'Hendelser',
    icon: (props) => EventsIcon({ fill: '#000', ...props }),
    activeIcon: EventsIcon,
    link: 'history',
  },
  {
    title: 'Tilstand',
    icon: (props) => DocumentsStateIcon({ fill: '#000', ...props }),
    activeIcon: DocumentsStateIcon,
    documentsToSignedOnly: true,
    link: 'condition',
  },
  {
    title: 'Dokumenter',
    icon: (props) => DocumentsIcon({ fill: '#000', ...props }),
    activeIcon: DocumentsIcon,
    link: 'documents',
  },
  {
    title: 'Rom',
    icon: (props) => RoomIcon({ fill: '#000', ...props }),
    activeIcon: RoomIcon,
    link: 'rooms',
  },
];

export const publicNavbarMenu = [
  {
    title: 'Hjem',
    icon: HomeIcon,
    activeIcon: HomeIconActive,
    link: 'home',
  },
  {
    title: 'Hendelser',
    icon: CalendarIcon,
    activeIcon: CalendarActiveIcon,
    link: 'history',
  },
  {
    title: 'Dokumenter',
    icon: FileIcon,
    activeIcon: FileActiveIcon,
    link: 'documents',
  },
  {
    title: 'Rom',
    icon: PersonShelter,
    activeIcon: (props) => PersonShelter({ fill: '#164144', ...props }),
    secondary: true,
    link: 'rooms',
  },
  {
    title: 'Logg inn',
    icon: LoginIcon,
    activeIcon: LoginIcon,
    link: 'login',
  },
];

export const bmPlusNavbarMenu = [
  {
    id: 0,
    title: 'Oversikt',
    icon: (props) => BoligmappaPlusHomeIcon({ ...props }),
    activeIcon: (props) => BoligmappaPlusHomeIcon({ ...props }),
    link: '/personal-area/dashboard/boligmappa-plus',
  },
  {
    id: 1,
    title: 'Personlig område',
    icon: PersonalAreaIcon,
    activeIcon: PersonalAreaIcon,
    link: '/personal-area/dashboard/documents',
  },
  {
    id: 2,
    title: 'Kontrakter og maler',
    icon: ContractTemplatesIcon,
    activeIcon: ContractTemplatesIcon,
    link: '/personal-area/dashboard/contract-templates',
  },
  {
    id: 3,
    title: 'Verdi og økonomi',
    icon: ChartLine,
    activeIcon: ChartLine,
    link: 'financials',
    propertyRequired: true,
    isDisabledInApp: true,
  },
];

export const personalAreaMobileNavbarMenu = [
  {
    title: 'Hjem',
    icon: HouseSimpleIcon,
    activeIcon: HomeIconActive,
    link: '/personal-area/dashboard/home',
  },
  {
    title: 'Mine dokumenter',
    icon: FileIcon,
    activeIcon: FileActiveIcon,
    link: '/personal-area/dashboard/documents',
  },
  {
    title: 'Kontrakter og maler',
    icon: ContractTemplate,
    activeIcon: ContractTemplateActive,
    link: '/personal-area/dashboard/contract-templates',
  },
  {
    title: 'Boligmappa+',
    icon: BoligmappaFolder,
    activeIcon: BoligmappaFolderActive,
    isDisabledInApp: true,
    link: 'boligmappa-plus',
  },
];

export const servicesNavbarMenu = [
  {
    id: 0,
    title: 'Finn håndverker',
    icon: ScrewDriverIcon,
    activeIcon: ScrewDriverIcon,
    mobileIcon: ScrewDriverIcon,
    propertyRequired: true,
    link: 'more/find-professional',
  },
  {
    id: 1,
    title: 'Skaff dokumentasjon',
    icon: FileFolderIcon,
    activeIcon: MDRIcon,
    mobileIcon: FileFolderIcon,
    propertyRequired: true,
    link: 'create-mdr',
  },
  {
    id: 2,
    title: 'Leverandører',
    icon: ToolBoxIcon,
    activeIcon: ToolBoxIcon,
    mobileIcon: ToolBoxIcon,
    propertyRequired: true,
    link: 'vendors',
  },
  {
    id: 3,
    title: 'Hjelpeside',
    icon: SupportMenuItemIcon,
    activeIcon: SupportMenuItemIcon,
    mobileIcon: SupportMenuItemIcon,
    link: 'https://support.boligmappa.no',
    isExternalLink: true,
    openInNewTab: true,
  },
];

export const newMobileMenu = (properties) => [
  {
    id: 0,
    title: 'Hjem',
    icon: DoorIcon,
    link: '/dashboard/overview',
  },
  ...(properties || []).map((el) => ({
    id: el.boligmappaNumber,
    title: getPropertyAddress(el),
    boligmappaNumber: el.boligmappaNumber,
    icon: HousePentagonAltIcon,
    items: privateNavbarMenu,
  })),
  {
    id: 1,
    title: 'Din konto',
    icon: () => ProfileIcon({ width: 20, height: 20, fill: '#000' }),
    link: '/personal-area/dashboard/more/account',
  },
  {
    id: 2,
    title: 'Meldinger',
    icon: () => Bell({ width: 20, height: 21 }),
    link: '/personal-area/dashboard/notifications',
  },
  // {
  //   id: 3,
  //   title: 'Del din Boligmappe',
  //   icon: () => PrivateSharingIcon({ width: 20, height: 20 }),
  //   ownedPropertyRequired: true,
  //   hideInSharedProperty: true,
  //   link: '/more/private-share',
  // },
];
